import { render, staticRenderFns } from "./common-button.vue?vue&type=template&id=4a393e77&scoped=true"
import script from "./common-button.vue?vue&type=script&lang=js"
export * from "./common-button.vue?vue&type=script&lang=js"
import style0 from "./common-button.vue?vue&type=style&index=0&id=4a393e77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a393e77",
  null
  
)

export default component.exports